<template>
  <div class="wrap">
    <div class="toolbar">
      <div class="title">订单日志明细表</div>
      <div class="actions">
        <el-form :inline="true">
          <el-form-item label="订单编号">
            <el-input v-model="orderNo" placeholder="订单编号" clearable style="width: 180px" />
          </el-form-item>
          <el-form-item label="用户手机号">
            <el-input v-model="userPhone" placeholder="手机号" clearable style="width: 150px" />
          </el-form-item>
          <el-form-item label="商品名称">
            <el-input v-model="goodsName" placeholder="商品名称" clearable style="width: 180px" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" @click="search">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-main class="flex-container">
      <el-table
        :data="list"
        border
        stripe
        v-loading="loading"
        element-loading-text="加载中..."
        style="flex: 1"
      >
        <el-table-column prop="orderNo" label="订单编号" width="200" show-overflow-tooltip />
        <el-table-column prop="userPhone" label="用户手机号" width="130" />
        <el-table-column prop="goodsName" label="商品名称" width="200" show-overflow-tooltip />
        <el-table-column prop="createDate" label="下单日期" width="120" />
        <el-table-column prop="createTime" label="下单时间" width="100" />
        <el-table-column prop="dt" label="统计日期" width="120" />
        <el-table-column prop="remark" label="备注" show-overflow-tooltip />
      </el-table>

    </el-main>

    <el-footer class="el-footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-footer>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'OrderLogDetail',
  data() {
    return {
      loading: false,
      orderNo: '',
      userPhone: '',
      goodsName: '',
      list: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      chart: null,
      resizeHandler: null,
    }
  },
  computed: {
    // 图表：当前页中商品出现的次数（按商品名聚合）
    goodsNames() {
      const map = new Map()
      ;(this.list || []).forEach(item => {
        const name = item.goodsName
        if (name) map.set(name, (map.get(name) || 0) + 1)
      })
      return Array.from(map.keys())
    },
    goodsCounts() {
      const map = new Map()
      ;(this.list || []).forEach(item => {
        const name = item.goodsName
        if (name) map.set(name, (map.get(name) || 0) + 1)
      })
      return Array.from(map.values())
    },
  },
  mounted() {
    this.getData()
    this.resizeHandler = () => {
      if (this.chart) this.chart.resize()
    }
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler)
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
    if (this.searchTimer) {
      clearTimeout(this.searchTimer)
      this.searchTimer = null
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    search() {
      this.currentPage = 1
      this.getData()
    },
    toNumber(v) {
      const n = Number(v)
      return Number.isFinite(n) ? n : 0
    },
    getData() {
      this.loading = true
      this.$axios.get('/hadoop/orderLogDetail', {
        params: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          orderNo: this.orderNo,
          userPhone: this.userPhone,
          goodsName: this.goodsName,
        },
      })
        .then(res => {
          this.total = res.data.data.total
          this.list = res.data.data.records
          this.loading = false
          this.$nextTick(() => this.renderChart())
        })
        .catch(() => {
          this.loading = false
        })
    },
    renderChart() {
      const el = this.$refs.chart
      if (!el) return
      if (!this.chart) this.chart = echarts.init(el)

      const option = {
        title: { text: '当前页商品订单数量（按商品名）', left: 'center' },
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: 120, right: 30, top: 80, bottom: 30 },
        xAxis: { type: 'value', name: '订单数量' },
        yAxis: { type: 'category', data: this.goodsNames, inverse: true, name: '商品名称' },
        series: [
          {
            name: '订单数量',
            type: 'bar',
            data: this.goodsCounts,
            itemStyle: { color: '#67C23A' },
            label: { show: true, position: 'right' },
          },
        ],
      }
      this.chart.setOption(option, true)
    },
  },
}
</script>

<style scoped>
.wrap {
  padding: 16px;
}
.toolbar {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.title {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
  line-height: 32px;
}
.actions {
  display: flex;
  align-items: center;
  margin-left: 100px;
}
.chart {
  height: 1000px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  flex-shrink: 0;
  width: 800px;
}
.flex-container {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/OrderLogDetail.vue